import * as actionTypes from "../types";

const initialState = {
    transactions: [],
    transactionEmpty: false,
    reserveBookID: [], 
    returnTransactions: [], 
    returnEmpty: false,
    returnBookID: [],
    penaltyTransactions: [], 
    penaltyEmpty: false,
    penaltyBookID: [],

    transactBook: [], 
    bookEmpty: false,
    lateNumber: 0,
    lateNumberEmpty: false,
    numberEmpty: false,
    returnNumberEmpty: false,
    requestNumberEmpty: false, 
    number: 0, 
    returnNumber: 0,
    requestNumber: 0,
    dashboardNumbers: []
}

export default function transactionReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_TRANSACTIONS: {
            return {
                ...state,
                transactions: action.payload.transactions,
                transactionEmpty: action.payload.transactionEmpty,
                reserveBookID: action.payload.bookID
            };
        }
        case actionTypes.GET_RETURNED_TRANSACTIONS: {
            return {
                ...state,
                returnTransactions: action.payload.transactions,
                returnEmpty: action.payload.transactionEmpty,
                returnBookID: action.payload.bookID
            };
        }
        case actionTypes.GET_PENALTY_TRANSACTIONS: {
            return {
                ...state,
                penaltyTransactions: action.payload.transactions,
                penaltyEmpty: action.payload.transactionEmpty,
                penaltyBookID: action.payload.bookID
            };
        }
        case actionTypes.GET_TRANSACT_BOOKS: {
            return {
                ...state,
                transactBook: action.payload.borrowedBooks,
                bookEmpty: action.payload.borrowedBooksEmpty
            };
        }
        case actionTypes.RESET_TRANSACTIONS: {
            return {
                ...state,
                transactBook: action.payload.borrowedBooks,
                bookEmpty: action.payload.borrowedBooksEmpty,
                transactPeople: action.payload.borrowerDetails,
                peopleEmpty: action.payload.borrowerEmpty
            };
        }
        case actionTypes.GET_NUMBER: {
            var currentArray = state.dashboardNumbers;
            currentArray.push(action.payload.number)
            return {
                ...state,
                number: action.payload.number,
                numberEmpty: action.payload.numberEmpty,
                dashboardNumbers: currentArray
            };
        }
        case actionTypes.GET_LATE_NUMBER: {
            var lateArray = state.dashboardNumbers
            lateArray.push(action.payload.number)
            return {
                ...state,
                lateNumber: action.payload.number,
                lateNumberEmpty: action.payload.numberEmpty,
                dashboardNumbers: lateArray

            };
        }
        case actionTypes.GET_RETURN_NUMBER: {
            var arrayReturn = state.dashboardNumbers
            arrayReturn.push(action.payload.number)
            return {
                ...state,
                returnNumber: action.payload.number,
                returnNumberEmpty: action.payload.numberEmpty,
                dashboardNumbers: arrayReturn
            };
        }
        case actionTypes.GET_REQUEST_NUMBER: {
            var damageArray = state.dashboardNumbers
            damageArray.push(action.payload.number)
            return {
                ...state,
                requestNumber: action.payload.number,
                requestNumberEmpty: action.payload.numberEmpty,
                dashboardNumbers: damageArray
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}


